import { prospectSystemStateMapping as systemStates } from '@scoir/my-colleges/lane-grouping'
import { find, isUndefined, size, some } from 'lodash'
import moment from 'moment'

import {
  bifurcate,
  hasSelectedAcceptableNonCollegiateOutcome,
} from 'components/GraduatePlanner/application-outcome-helper'

export const isWithinWindow = (someDate, gradYear) => moment(someDate).isSameOrAfter(moment(`${gradYear}-04-01`), 'day')

export const types = {
  EnrollingAndPending: 'ENROLLING_PENDING',
  NotEnrollingAndPending: 'NO_ENROLLING_PENDING',
  NoOutcome: 'NO_NCO',
  NoOutcomeWithApplications: 'APPLICATIONS_WITHOUT_NCO',
  Enrolling: 'ENROLLING',
  NCOProvided: 'NCO_PROVIDED',
  NotASenior: 'NOT_A_SENIOR',
  NotWithinTimeWindow: 'NOT_WITHIN_TIME_WINDOW',
  ConflictingOutcome: 'ENROLLING_AND_NCO',
}

const matchesType = (types, type) => some(types, (allowedType) => allowedType === type)

export const isPromptType = (type) =>
  matchesType(
    [types.EnrollingAndPending, types.NotEnrollingAndPending, types.NoOutcome, types.NoOutcomeWithApplications],
    type,
  )

export const isWidgetType = (type) => !matchesType([types.NotASenior, types.NotWithinTimeWindow], type)

export const isFinaliazedOutcomeType = (type) =>
  matchesType(
    [
      types.Enrolling,
      types.NCOProvided,
      types.ConflictingOutcome, // I think at one point this was a prompt type
    ],
    type,
  )

export const getNCOPromptInfo = (
  isSenior,
  nonCollegiateOutcome,
  prospects,
  currentGraduationYear,
  considerRolloverWindow = true, // useful for testing
) => {
  let type
  let pending
  let decided
  let enrollingCollege
  if (!isSenior) {
    type = types.NotASenior
  } else if (!considerRolloverWindow || isWithinWindow(moment(), currentGraduationYear)) {
    const [_pending, _decided] = bifurcate(prospects)
    pending = _pending
    decided = _decided
    const hasPending = size(pending) > 0
    const hasApplied = size(decided) > 0
    enrollingCollege = find(decided, { SystemState: systemStates.Enrolling })
    const hasEnrollingCollege = !isUndefined(enrollingCollege)
    const hasNonCollegiate = hasSelectedAcceptableNonCollegiateOutcome(nonCollegiateOutcome)

    if (hasPending) {
      type = hasEnrollingCollege ? types.EnrollingAndPending : types.NotEnrollingAndPending
    } else if (!hasEnrollingCollege && !hasNonCollegiate) {
      type = hasApplied ? types.NoOutcomeWithApplications : types.NoOutcome
    } else if (hasEnrollingCollege && hasNonCollegiate) {
      type = types.ConflictingOutcome
    } else if (hasEnrollingCollege) {
      type = types.Enrolling
    } else {
      type = types.NCOProvided
    }
  } else {
    type = types.NotWithinTimeWindow
  }
  return {
    type,
    pending,
    decided,
    enrollingCollege,
  }
}

export const shouldPrompt = (isSenior, nonCollegiateOutcome, prospects, currentGraduationYear) => {
  const { type } = getNCOPromptInfo(isSenior, nonCollegiateOutcome, prospects, currentGraduationYear)
  return isPromptType(type)
}
